import { Route, Switch } from "react-router-dom";

import Add from "./Users/Add/Add";
import AddBulk from "./Users/Add/AddBulk";
import Alerts from "./Alerts/Alerts";
import Incidents from "./Incidents/Incidents";
import EditIncident from "./Incidents/Edit/Edit";
import Edit from "./Users/Edit/Edit";
import OrgSiteDept from "./OrgSiteDept/OrgSiteDept";
// import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";
import React from "react";
import Users from "./Users/Users";
import AddNewIncident from "./Incidents/Add/Add";
import NotFound from "views/Welcome/NotFound";

const Maintain = props => {
    return (
        <React.Fragment>
            {/* <ProtectedRoute> */}
            {/* Switch Routes below */}
            <Switch>
                <Route exact path="/maintain/alerts" component={Alerts} />
                <Route exact path="/maintain/incidents" component={Incidents} />
                <Route
                    exact
                    path="/maintain/incidents/edit"
                    component={EditIncident}
                />
                <Route
                    exact
                    path="/maintain/incidents/add-new-incident"
                    component={AddNewIncident}
                />
                <Route
                    exact
                    path="/maintain/org-site-dept"
                    component={OrgSiteDept}
                />
                <Route exact path="/maintain/users" component={Users} />
                <Route exact path="/maintain/users/add" component={Add} />
                <Route exact path="/maintain/users/add_bulk" component={AddBulk} />
                <Route exact path="/maintain/users/edit" component={Edit} />
                <Route component={NotFound} />
            </Switch>
            {/* </ProtectedRoute> */}
        </React.Fragment>
    );
};

export default Maintain;
